import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { images } from "../../config/images";
import { getAcConditioningStationDetails } from "../ProductionLine/services";
import { toast } from "react-toastify";

const AcConditioning = ({ setAcConditioner, batchId }) => {
  const [acConditioningData, setAcConditioningData] = useState([]);

  useEffect(() => {
    handleGetAcConditioningData();
  }, [batchId]);

  const handleGetAcConditioningData = async () => {
    try {
      const resp = await getAcConditioningStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setAcConditioningData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setAcConditioningData([]);
      console.log("handlesubmit", error);
    }
  };
  return (
    <>
      <div className="modal-container" style={{ height: "40vh", top: "35vh" }}>
        <div className="modal-header">
          <div className="modal-title">AC CONDITIONING PROCESS SHEET</div>
          <div
            onClick={() => setAcConditioner(false)}
            style={{ cursor: "pointer" }}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="modal-table-wrapper">
          <div
            style={{
              width: "100%",
              overflow: "auto",
              maxHeight: "400px",
            }}
            className="gloves-report-data"
          >
            <Table className="dipping-params">
              <TableHead>
                <TableRow>
                  <TableCell>Class</TableCell>
                  <TableCell>Size</TableCell>
                  <TableCell>RE.SC</TableCell>
                  <TableCell>Bin. No</TableCell>
                  <TableCell>QTY</TableCell>
                  <TableCell>Start Date</TableCell>
                  <TableCell>Start Time</TableCell>
                  <TableCell>End Date</TableCell>
                  <TableCell>End Time</TableCell>
                  <TableCell>Require Time</TableCell>
                  <TableCell>Actual Time</TableCell>
                  <TableCell>Operator Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="gloves-report-body">
                {acConditioningData?.map((e) => {
                  return (
                    <TableRow>
                      <TableCell>
                        {e.class_name ? e.class_name : "--"}
                      </TableCell>
                      <TableCell>{e.size_name ? e.size_name : "--"}</TableCell>
                      <TableCell>{e.sc_re ? e.sc_re : "--"}</TableCell>
                      <TableCell>
                        {e.bin_number ? e.bin_number : "--"}
                      </TableCell>
                      <TableCell>{e.quantity ? e.quantity : "--"}</TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_start_time
                            ? dayjs(e.cycle_start_time).format("YYYY-MM-DD")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_start_time
                            ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>

                      <TableCell>
                        {e
                          ? e?.cycle_end_time
                            ? dayjs(e.cycle_end_time).format("YYYY-MM-DD")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_end_time
                            ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>
                        {e.require_time ? e.require_time : "--"}
                      </TableCell>
                      <TableCell>
                        {e.actual_time ? e.actual_time : "--"}
                      </TableCell>
                      <TableCell>{e.operator ? e.operator : "--"}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
      <div
        className="modal-overlay"
        onClick={() => setAcConditioner(false)}
      ></div>
    </>
  );
};

export default AcConditioning;
